import React from 'react';
import { classNameBuilder } from '../../../utils/className';

import './limiterBlock.scss';

interface IProps {
    typeContainer?: 'large' | 'image';
    size?: 'full';
    className?: string;
}

const LimiterBlock: React.FC<React.PropsWithChildren<IProps>> = ({
    children,
    typeContainer = 'image',
    size,
    className = '',
}) => {
    const cn = classNameBuilder('limiterBlock');
    const mod = {
        typeContainer: typeContainer,
        size: size,
    };

    return <div className={`${cn(mod)} ${className}`}>{children}</div>;
};

export default LimiterBlock;
